module.exports = __webpack_public_path__ + "media/images/flags/64/Gambia-a3b04c75526efcdb58ca1c18c3d3086b.png";